import { ROUTES } from 'constants/routes';
import { useAuthenticatedAxios } from 'hooks/useAuthenticatedAxios';
import { useMswManager } from 'lib/util/useMswManager';
import { useMutation } from 'react-query';
import { ErrorResponse } from 'types/network';
import { HrznGatewayMswBuilder } from 'stories/HrznGatewayMswBuilder';
import { useSnackbar } from 'notistack';

export interface VoidEncounterPayload {
  encounterHeaderIdentifier: number | number[];
  encounterHeaderVoidReasonID: number;
  comment?: string;
}

export const usePartnerVoidEncounter = (isMulti = false) => {
  const Axios = useAuthenticatedAxios();
  const { enqueueSnackbar } = useSnackbar();

  // Setup MSW mock for both single and multiple void
  useMswManager([
    HrznGatewayMswBuilder.create().post(
      ROUTES.PartnerUpSertEncounterHeaderStatusVoidUpdate,
      {
        data: 'Records Voided Successfully'
      }
    ),
    HrznGatewayMswBuilder.create().post(
      ROUTES.UpSertEncounterHeaderStatusVoidUpdateMultiple,
      {
        data: 'Records Voided Successfully'
      }
    )
  ]);

  return useMutation<void, ErrorResponse, VoidEncounterPayload>(
    async payload => {
      const { data } = await Axios({
        method: 'post',
        url: `/?route=${
          isMulti
            ? ROUTES.UpSertEncounterHeaderStatusVoidUpdateMultiple
            : ROUTES.PartnerUpSertEncounterHeaderStatusVoidUpdate
        }`,
        data: payload
      });
      return data;
    },
    {
      onError: (error: ErrorResponse) => {
        enqueueSnackbar(error.message || 'Failed to void encounter', {
          variant: 'error'
        });
      }
    }
  );
};
